import { useState } from "react";
import styled from "styled-components";
import { Flexed, Text } from "../../styled/shared";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ProductDetailsModal from "../modals/ProductDetailsModal";
import { getProductById } from "../../apis/apis";
const SellersProducts = (content) => {
  const images = content.content.reduce((acc, cv) => {
    // Map each image to include the product ID
    const productImages = cv.images.map((img) => ({
      image: img,
      productId: cv.id
    }));
    return [...acc, ...productImages];
  }, []);

  const AWS_URL = "https://imagescontent.s3.us-east-1.amazonaws.com";

  const [singleProduct, setSingleProduct]: any = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const handleProductModal = async (id) => {
    const response = await getProductById(id);
    setSingleProduct(response);
    setIsDetailsModalOpen(true);
  };

  const addToCart = (event: any) => {
    const targetParent = event.target.parentNode;
    const img = targetParent.querySelector("img");
    const clone = img.cloneNode();
    targetParent.appendChild(clone);
  };

  return (
    <div>
      <OwlCarousel
        responsive={Responsive}
        nav={true}
        autoplay
        className="owl-carousel owl-theme"
      >
        {/* // <OwlCarousel responsive={Responsive} autoplay autoplayTimeout={3000} loop className="owl-carousel owl-theme"> */}
        {images.productImages?.length === 0 && (
          <Flexed justifyContent="center" alignItems="center" height="100%">
            <Text fontSize="1.5rem" color="#868686" fontWeight="700">
              No images available
            </Text>
          </Flexed>
        )}
        {images?.map((img, index) => {
          return (
            <Img
              key={"carousel" + index}
              src={`${AWS_URL}/${img.image}`}
              onClick={() => {
                handleProductModal(img.productId);
              }}
            />
          );
        })}
      </OwlCarousel>
      {isDetailsModalOpen && (
        <ProductDetailsModal
          content={singleProduct}
          addToCart={addToCart}
          sale={singleProduct?.discount > 0 ? true : false}
          productPurchase={false}
          soldProducts={false}
          donation={singleProduct?.is_donation}
          onClose={() => {
            setIsDetailsModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

const Img = styled.img<any>`
  object-fit: cover;
  width: 200px;
  height: 200px;
  border-radius: 1.25rem;
`;

const Responsive = {
  0: {
    items: 1,
    margin: 20
  },
  600: {
    items: 2,
    margin: 20
  },
  992: {
    items: 2,
    // loop: false,
    margin: 20
  },
  1400: {
    items: 3,
    // loop: false,
    margin: 20
  }
};

export default SellersProducts;
